import { colors } from '../styles/colors'
import type { VoteSubmitDto } from '../types/generated'
import { VoteSubmitDtoStatusEnum } from '../types/generated'

export interface VoteStatusFlags {
  isError: boolean
  isProcessing: boolean
}

/**
 * Determines the visual state of a vote submission based on its status
 * @param vote - The vote submission DTO
 * @returns Flags indicating if the vote is in error or processing state
 */
export function getVoteStatusFlags(vote: VoteSubmitDto): VoteStatusFlags {
  const isError =
    vote.status === VoteSubmitDtoStatusEnum.INITIAL_FAILED ||
    vote.status === VoteSubmitDtoStatusEnum.CHILD_FAILED ||
    vote.status === VoteSubmitDtoStatusEnum.NOT_FOUND

  const isProcessing =
    vote.status === VoteSubmitDtoStatusEnum.RECEIVED ||
    vote.status === VoteSubmitDtoStatusEnum.PROCESSING

  return {
    isError,
    isProcessing,
  }
}

/**
 * Returns the color for a given status
 * @param status - The status to get the color for
 * @returns The color for the status
 */
export const getColorByStatus = (status: VoteSubmitDtoStatusEnum) => {
  switch (status) {
    case VoteSubmitDtoStatusEnum.INITIAL_FAILED:
    case VoteSubmitDtoStatusEnum.CHILD_FAILED:
    case VoteSubmitDtoStatusEnum.NOT_FOUND:
      return colors.danger

    case VoteSubmitDtoStatusEnum.ACCEPTED:
      return colors.grey700

    case VoteSubmitDtoStatusEnum.PROCESSING:
    case VoteSubmitDtoStatusEnum.RECEIVED:
      return colors.successActive
  }
}
